import React, { useEffect, useContext, useState, useMemo } from 'react';
import Badge from '../../../components/base/Badge';
import RevealDropdown, {
  RevealDropdownTrigger
} from '../../../components/base/RevealDropdown';
import { useMainLayoutContext } from '../../../providers/MainLayoutProvider';
import { Col, Dropdown, Row } from 'react-bootstrap';
import { UilStopwatch } from '@iconscout/react-unicons';
import TaskCompletedGant from '../../../components/project-management/project-details/TaskCompletedGant';
import WorkLoads from '../../../components/project-management/project-details/WorkLoads';
import ConsumptionDetails from '../../production-management/ConsumptionDetails';
import TeamMembers from '../../../components/project-management/project-details/TeamMembers';
import ProjectDetailsSummary from '../../../components/project-management/project-details/ProjectDetailsSummary';
import ActivityTimeline from '../../../components/timelines/ActivityTimeline';
import { activityTimelineData } from '../../../data/project-management/activityTimelineData';
import MachineCounterChart from '../../../components/charts/machines-charts/MachineTotalProduction';
import Ach300MaxSpeedAndLinearSpeed from '../../../components/charts/machines-charts/MachineMaxSpeedAndLinearSpeed';
import MachineSpeedGauge from '../../../components/charts/machines-charts/MachineSpeedGauge';
import { MachineDataContext } from '../../../providers/MachineDataContext';
import MachineTotalMetersChart from '../../../components/charts/machines-charts/MachineTotalMetersChart';
import getShiftStartEndTime, {
  updateTimeRange
} from '../../../components/charts/utils/chartUtils';
import { useAppContext } from '../../../providers/AppProvider';
import MachineMaxSpeedAndLinearSpeed from '../../../components/charts/machines-charts/MachineMaxSpeedAndLinearSpeed';
import { Hourglass } from 'react-loader-spinner';
import MachineAmpsGraph from '../../../components/charts/machines-charts/MachineAmpsGraph';
import MachineMaxActCounterChart from '../../../components/charts/machines-charts/MachineMaxActCounterChart';
import MachinePercentageLineChart from '../../../components/charts/machines-charts/MachinePercentageLineChart';
import MachimeTime from '../../../components/cards/MachimeTime';
import MachineTraverseChart from '../../../components/charts/machines-charts/MachineTraverseChart';
import MachineTotalProduction from '../../../components/charts/machines-charts/MachineTotalProduction';
import ActiveBreakTimeBarChart from '../../../components/charts/machines-charts/ActiveBreakTimeBarChart';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import {
  faAngleRight,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DisplayShift from '../../../components/base/DisplayShift';
import LazyLoadChart from '../../../components/common/LazyLoadChart';
import { WebSocketContext } from '../../../providers/WebSocketProvider';
import '../../../components/machines/trackingHeader.css';

const LDtbTraking = () => {
  const initialShiftTimes = getShiftStartEndTime();

  const currentDay = dayjs();
  console.log('LDTB  MOUNTED');
  const { setContentClass } = useMainLayoutContext();

  const { machineSingle, subscribeToChannel, unsubscribeToChannel } =
    useContext(WebSocketContext);

  // Memoize reversed reports with a fallback for undefined reports
  const reversedReports = useMemo(
    () =>
      machineSingle?.state?.reports
        ? machineSingle.state.reports.slice().reverse()
        : [],
    [machineSingle?.state?.reports]
  );

  // State for startTime and endTime
  const [timeRange, setTimeRange] = useState({
    startTime: initialShiftTimes.startTime,
    endTime: initialShiftTimes.endTime
  });
  const { startTime, endTime } = timeRange;
  const isWithinShift = currentDay.isBetween(
    dayjs(timeRange.startTime),
    dayjs(timeRange.endTime)
  );

  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  const handleUpdate = direction => {
    const { startTime, endTime } = updateTimeRange(timeRange, direction);

    setTimeRange(prevRange => ({
      startTime,
      endTime
    }));
  };
  useEffect(() => {
    setContentClass('px-0 pt-navbar');

    return () => {
      setContentClass('');
    };
  }, []);
  useEffect(() => {
    console.log('Subscribing to machine-all channel');
    subscribeToChannel('machine-single', 'dtb1250');

    return () => {
      console.log('UNSUBSCRIBING from machine-all channel');
      unsubscribeToChannel();
    };
  }, []);

  if (!machineSingle || machineSingle.machine !== 'dtb1250') {
    return (
      <div style={styles.spinnerContainer}>
        <Hourglass
          colors={
            theme === 'dark' ? ['#306cce', '#72a1ed'] : ['#306cce', '#306cce']
          }
          visible={true}
          ariaLabel="hourglass-loading"
          height="80"
          width="80"
          // wrapperStyle ={styles.spinnerContainer}
        />
      </div>
    );
  }

  return (
    <Row className="g-0 border-bottom border-300">
      <Col xs={12} xxl={isWithinShift ? 8 : 12} className="px-0 bg-soft">
        <div className="px-4 px-lg-6 pt-6 pb-9">
          <div className="mb-5">
            <div className="tracking-header">
              {/* Machine Overview */}
              <h2 className="text-black fw-bolder mb-2 tracking-header__title">
                Machine DTB 1250 overview
              </h2>

              {/* Timeline: Center-aligned */}
              <div
                className="d-flex align-items-center mx-auto"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                <button
                  className="btn btn-link p-0"
                  aria-label="Previous date"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition:
                      'transform 0.3s ease, background-color 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.target.style.backgroundColor = '#004DFF';
                    theme === 'dark'
                      ? (e.target.style.color = 'white')
                      : (e.target.style.color = 'black');
                  }}
                  onMouseLeave={e =>
                    (e.target.style.backgroundColor = 'transparent')
                  }
                  onClick={() => {
                    console.log('LEFT CLICK');
                    handleUpdate(-1);
                  }} // Decrease by 12 hours
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    style={{
                      fontSize: '16px',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                >
                  {dayjs(startTime).format('MMMM D, YYYY, h:mm A')}
                </span>
                <button
                  className="btn btn-link p-0"
                  aria-label="Next date"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition:
                      'transform 0.3s ease, background-color 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.target.style.backgroundColor = '#004DFF';
                    theme === 'dark'
                      ? (e.target.style.color = 'white')
                      : (e.target.style.color = 'black');
                  }}
                  onMouseLeave={e =>
                    (e.target.style.backgroundColor = 'transparent')
                  }
                  onClick={() => {
                    handleUpdate(1);
                    console.log('RIGHT CLICK');
                  }} // Increase by 12 hours
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                      fontSize: '16px',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>
              </div>
              {/* Right half — sizing lives in trackingHeader.css */}
              <div className="tracking-header__aside">
                <DisplayShift
                  machineName={'dtb1250'}
                  bucket={'machine_data'}
                  startTime={startTime}
                  endTime={endTime}
                />

                <RevealDropdownTrigger>
                  <RevealDropdown>
                    <Dropdown.Item>Edit</Dropdown.Item>
                    <Dropdown.Item className="text-danger">Delete</Dropdown.Item>
                    <Dropdown.Item>Download</Dropdown.Item>
                    <Dropdown.Item>Report abuse</Dropdown.Item>
                  </RevealDropdown>
                </RevealDropdownTrigger>
              </div>
            </div>
            <Badge
              variant="phoenix"
              bg={machineSingle.state.status.type}
              iconPosition="end"
              icon={<UilStopwatch size={12} className="ms-1" />}
            >
              {machineSingle.state.status?.label}
            </Badge>
          </div>
          <Row className="gx-0 gx-sm-5 gy-8 mb-8">
            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
              {/* TOTAL METER PRODUCED */}
              <LazyLoadChart>
                <MachineTotalProduction
                  bucket={'machine_data'}
                  machineName={'dtb1250'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <MachimeTime
                  bucket={'machine_data'}
                  machineName={'dtb1250'}
                  time={'totalActiveTime'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <MachimeTime
                  bucket={'machine_data'}
                  machineName={'dtb1250'}
                  time={'totalBreakTime'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={5} lg={12} xl={12} xxl={12}>
              <LazyLoadChart>
                <ActiveBreakTimeBarChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_30minute'}
                  machineName={'dtb1250'}
                  fields={'ACTIVE_TIME,BREAK_TIME'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Active Break Time'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={5} lg={12} xl={12} xxl={12}>
              {/* TOTAL METER PRODUCED */}
              <LazyLoadChart>
                <MachineTotalMetersChart
                  bucket={'machine_data_minute'}
                  dynamicBucket={'true'}
                  machineName={'dtb1250'}
                  fields={'total_produced'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={3} xxl={4} className="pe-xl-0">
              {/* LINE SPEED  GAUGE  */}
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'Line Speed'}
                  speed={machineSingle.state.currentPlcState.ACT_RAMP_VALUE_PER}
                  startTime={startTime}
                  endTime={endTime}
                />
              )}
            </Col>
            <Col xs={12} xl={9} xxl={isWithinShift ? 8 : 12}>
              {/* MAX SPEED LINIEAR SPEED */}
              <LazyLoadChart>
                <MachineMaxSpeedAndLinearSpeed
                  bucket={'machine_data_minute'}
                  machineName={'dtb1250'}
                  dynamicBucket={'true'}
                  fields={'MAX_RAMP_VALUE_PER,ACT_RAMP_VALUE_PER'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineAmpsGraph
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'dtb1250'}
                  fields={'BOW_CURRENT'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Distibution of electricity Bow DTB1250'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineAmpsGraph
                  bucket={'machine_data_minute'}
                  dynamicBucket={'true'}
                  machineName={'dtb1250'}
                  fields={'CAPSTAN_CURRENT'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Distibution of electricity Capstan DTB1250'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={12} xl={12}>
              <LazyLoadChart>
                <MachineMaxActCounterChart
                  bucket={'machine_data_minute'}
                  machineName={'dtb1250'}
                  fields={'METER_ACT'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={6} xxl={6}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Bow Rpm'}
                  machineName={'dtb1250'}
                  fields={'BOW_MAX_RPM'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={6} xxl={6}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Bow Twist'}
                  machineName={'dtb1250'}
                  fields={'BOW_ACT_TWIST'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
          </Row>
        </div>
      </Col>
      {isWithinShift ? (
        <Col xs={12} xxl={4} className="px-0 border-start-xxl border-300">
          <div className="border-bottom border-300">
            <div className="bg-light dark__bg-1100 h-100">
              <div className="p-4 p-lg-6">
                <h3 className="text-1000 mb-4 fw-bold">Recent activity</h3>
                <ActivityTimeline reports={reversedReports} />
              </div>
            </div>
          </div>
        </Col>
      ) : (
        ''
      )}
    </Row>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  }
};

export default LDtbTraking;
